<div class="bg_overlay"></div>
<div class="flex_container">
  <notifications-inbox class="notif"></notifications-inbox>
  <task-feed class="tasks"
             [rightMenuContent]="true"
  ></task-feed>
</div>
